module.exports = __webpack_public_path__ + "img/tv-shortcut.252e8d1f.svg";